<template>
  <div v-cloak>
    <div id="breadcrumb">
      <ol class="breadcrumb">
        <li class="active">
          <small>Store</small>
        </li>
        <li class="active">
          <small>Distributor Store</small>
        </li>
        <li class="active">
          <small>Data Quality Checking</small>
        </li>
      </ol>
    </div>
    <div class="tab">
      <el-tabs class="el-tabs" type="border-card">
        <el-tab-pane label="Detail">
          <d1-vue-component
            ref="basicComponent"
            :options="generateOption"
            data-facet-key="data_quality_checking"
            :d1CoreBaseUrl="baseD1Url"
            :ControlMoreSeachType="true"
            :MoreAndSearchClickView="false"
            @handleTableValueClick="handleTableValueClick"
            @onToolbarButtonClick="handleToolbarButtonClick"
            @getTableSelectedRows="getSelectedList"
          ></d1-vue-component>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import d1VueComponent from "@/components/d1/d1-vue-component";
import store from "@/store";
export default {
  components: {
    d1VueComponent
  },
  data() {
    return {
      generateOption: {
        queryUrl: "/dataQuality/list?sort=gmt_modified,DESC",
        importUrl: "",
        exportUrl: "/dataQuality/export?sort=gmt_modified,DESC",
        deleteUrl: "",
        modifyUrl: "",
        pageSize: 10,
        tableData: [{}],
        pageSettingData: {
          form: [{}],
          table: [{}]
        },
        showToolbarButtonList: true, //是否显示工具栏
        asyncExport: true,
        showExportButton: true,
        showSelectColumn: true,
        showTableSelection: true,
        showTableOperationButton: false,
        toolbarButtonList: [
          //Tabl左上键按钮组合
          {
            label: "Recover ", //按钮显示的名称
            type: "success", //按钮的类型,默认空,支持  primary，success，info，warning，danger
            name: "recover", // 用户点击时返回的组件
            elColWidth: 3 //按钮的占位
          },
          {
            label: "Neglect ", //按钮显示的名称
            type: "danger", //按钮的类型,默认空,支持  primary，success，info，warning，danger
            name: "neglect", // 用户点击时返回的组件
            elColWidth: 3 //按钮的占位
          }
        ],
        openform: true,
        tableCellDataLink: [
          {
            db_field_name: "store_seq", //需要增加a标签的字段名
            field_label: [""], //a标签显示的限制值
            dialogDisplaysValueFromFields: "", // 对话框的说明来源于字段
            needCustomProcess: true, //如果设置为ture
            name: ""
          }
        ],
        showSelectColumn: true,
        pageTableType: "data_quality",
        ExchangeToolbarButtonPosition: true
      },
      selectRowIdList: []
    };
  },
  watch: {},
  computed: {},
  created() {
  },
  mounted() {},
  methods: {
    handleTableValueClick(row, dbFieldName) {
      if (dbFieldName === "store_seq") {
        let routeData = this.$router.resolve({
          path: "/store-detail",
          query: {
            id: row.store_id,
            storeSeq:row.store_seq,
            name: "Data Quality Checking",
            dmsId: row.dms_id,
            dmsStoreId: row.dms_store_id,
            subId: row.sub_id,
            status:row.status
          }
        });
        window.open(routeData.href, '_blank')
      }
    },
    // 表格上方按钮组点击事件
    handleToolbarButtonClick(name) {
        if(name == 'recover'){
            if(this.selectRowIdList.length==0){
              this.$message.warning("Please select records");
              return
            }
            //只能选择已完成
            if(!this.validateRecover()){
              this.$message.error("只能选择已完成状态的数据");
              return 
            }
            let url = this.baseStoreUrl + '/dataQuality/open'
            this.http.post(url,this.selectRowIdList).then(res=>{
              this.$message.success('操作成功')
              this.selectRowIdList = []
              this.$refs.basicComponent.runQuery();
            })
        }else if(name=='neglect'){
            if(this.selectRowIdList.length==0){
              this.$message.warning("Please select records");
              return
            }
            //只能选择待审批
            if(!this.validateNeglect()){
              this.$message.error("只能选择待审批状态的数据");
              return 
            }
            let url = this.baseStoreUrl + '/dataQuality/ignore'
            this.http.post(url,this.selectRowIdList).then(res=>{
              this.$message.success('操作成功')
              this.selectRowIdList = []
              this.$refs.basicComponent.runQuery();
            })
        }
    },
    getSelectedList(rowList) {
      this.selectRowIdList = []
      this.selectRowStatusList = []
      rowList.map(item=>{
        this.selectRowIdList.push(item.id) 
      })
      rowList.map(item=>{
        this.selectRowStatusList.push({status:item.status}) 
      })
    },
    validateRecover(){
      let arr = []
      this.selectRowStatusList.map(item=>{
        if(item.status=='待审批'){
          arr.push(item)
        }
      })
      if(arr.length>0){
        return false
      }else {
        return true
      }
    },
    validateNeglect(){
      let arr = []
      this.selectRowStatusList.map(item=>{
        if(item.status=='已完成'){
          arr.push(item)
        }
      })
      if(arr.length>0){
        return false
      }else {
        return true
      }
    }
  }
};
</script>

<style lang="scss" scoped>
[v-cloak] {
  display: none;
}
.breadcrumb {
  background-color: transparent !important;
  margin-bottom: 0px;
}
</style>



// WEBPACK FOOTER //
// src/view/store/data_quality/data_quality_checking.vue